import React from 'react';
// 顶部引入新增Tabs组件
import { NavBar, Tabs, List, Button, Collapse } from 'antd-mobile';
import '../../styles/styles.css';
import { OSS_PREFIX } from '../../oss.config';

// 在顶部新增导入
import FeatureQuickCheck from './FeatureQuickCheck';
import FAQ from './FAQ';

const ProductManual = () => {

  // 快速上手步骤
  const steps = [
    {
      title: '1. 准备工作',
      tips1: ['① 将超能眼镜佩戴在小可豆身上，佩戴方式：将眼镜绑带穿过小可豆头部两侧小孔，在后脑处将卡扣扣住。'],
      img1: `${OSS_PREFIX}/miniprogram/assets/pages/profiles/guide/tie_straps.png`,
      tips2: ['② 将小可豆的NFC小豆芽插入超能眼镜的豆芽仓中。'],
      img2: `${OSS_PREFIX}/miniprogram/assets/pages/profiles/guide/insert_nfc.png`,
    },
    {
      title: '2. 开机',
      img1: `${OSS_PREFIX}/miniprogram/assets/pages/profiles/guide/power_on_instructions.png`,
      warring1: '⚠️注意事项：\n 确保设备电量充足。'
    },
    {
      title: '3. 创建孩子',
      tips1: ['① 微信搜索并关注可豆陪陪服务号'],
      img1: `${OSS_PREFIX}/miniprogram/assets/pages/profiles/guide/weixin_server_logo.png`,
      tips2: ['② 进入家长端小程序'],
      img2: `${OSS_PREFIX}/miniprogram/assets/pages/profiles/guide/parent_app.png`,
      tips3: ['③ 根据指引完善孩子信息和相关设置'],
      img3: `${OSS_PREFIX}/miniprogram/assets/pages/profiles/guide/child_info_setting.png`,
      warring1:'⚠️注意事项：\n 后续有根据孩子年龄和性别特性推送的教育报告与建议，确保填写的信息准确无误，以保障报告效果。'
    },
    {
      title: '4. 配置网络并激活设备',
      tips1:['在小程序上创建孩子信息后，根据指引进行网络配置。'],
      tips2:['① 确保手机蓝牙打开，且定位服务开启，然后进入下一步。'],
      img1: `${OSS_PREFIX}/miniprogram/assets/pages/profiles/guide/network_configuration.png`,
      warring1:'⚠️注意事项：\n 不同手机的蓝牙和定位服务管理入口可能不同，请参考小程序指引图片进行设置，并以手机实际情况为准。',
      tips3: ['② 同时按住眼镜音量+和音量-两个按键，直到屏幕显示配网状态图后，进入下一步'],
      img2: `${OSS_PREFIX}/miniprogram/assets/pages/profiles/guide/wifi_enter_guide.png`,
      tips4: ['③ 手机靠近眼镜设备，等待小程序搜索到设备后，点击“连接“'],
      img3: `${OSS_PREFIX}/miniprogram/assets/pages/profiles/guide/wifi_connect_guide.png`,
      tips5: ['④ 填写Wifi账号和密码后，进入下一步，等待设备连接网络'],
      img4: `${OSS_PREFIX}/miniprogram/assets/pages/profiles/guide/wifi_detail_guide.png`,
      warring2:'⚠️注意事项：\n ① WiFi仅支持2.4G频段，5G频段无法使用。\n ② 若家里WiFi是5G频段，请把WiFi路由器设置为2.4G或双频合一模式。\n ③ 若使用手机热点，注意设置为2.4G频段。华为设备在“个人热点”设置界面中，找到“更多共享设置”或“显示高级选项”，即可设置。IOS设备在“个人热点”设置界面中，找到 “最大兼容性” 选项，将其开关打开，即可设置为 2.4GHz 频段。其它设备可在系统搜索“热点”关键词进入相应的界面进行设置。',
      tips6: ['⑤ 网络配置成功后，设备将自动重启，设备重启完成即可开始正常使用。'],
    },
    {
      title: '5. 开始使用',
      tips1: ['语音对话功能'],
      tips1Children: {
        tip:'当屏幕显示出小可豆的眼睛表情，清晰说出“可豆贝贝”，即可开始对话。',
        warring:'⚠️注意事项：\n 确保环境安静，语音清晰。如果环境嘈杂，会降低语音识别的正确率'
      },
      tips2: ['卡片互动功能'],
      tips2Children: {
        tip:'当屏幕显示出眼睛表情时，将卡片触碰眼镜右侧感应区，即可使用卡片互动功能。',
        img:`${OSS_PREFIX}/miniprogram/assets/pages/profiles/guide/card_guide.png`,
        warring:'⚠️注意事项：\n ① 为提高卡牌识别准确度，请将卡片中心位置紧贴感应区。\n ② 为保证互动体验的沉浸感，部分卡片游戏，需要对玩具说出“结束游戏”后才能开始日常对话。'
      },

    },
  ];

   const componentSpecs = [
    { part: '小可豆', desc: '每个小可豆有独特性格，孩子与它们的互动中，能潜移默化学习它们的优秀品质。比如：小熊卡卡可以激发孩子好奇心的，培养探索精神；小兔子罗西可以激发孩子的爱心和responsibility，学会理解和关心他人的感受。' },
    { part: '电源键', desc: '开机：长按3秒开机；关机：长按5秒关机；打断：与角色对话过程中，短按可以打断对话并回待机状态（此时可清晰说出“可豆贝贝”唤醒，开始对话）。' },
    { part: '音量键', desc: '增加音量：按“+”键；降低音量：按“-”键；配网模式：同时按住音量+、-键。' },
    { part: '卡片感应区', desc: '将NFC互动游戏卡中部触碰该区域，即可开始对应的互动玩法。' },
    { part: '显示屏', desc: '显示毛绒角色表情和交互信息，亮起表示开机。' },
    { part: '指示灯', desc: '充电时指示灯闪烁，充满电后指示灯常亮。' },
    { part: '充电口', desc: '使用符合规定的Type-C充电线插入充电口，接通电源即可充电。' },
    { part: '绑带', desc: '小可豆佩戴超能眼镜：将眼镜绑带穿过小可豆头部两侧的小孔，在后脑处将卡扣扣住。' },
    { part: '豆芽仓', desc: '将小可豆的NFC小豆芽插入豆芽仓，系统识别小可豆身份后与孩子进行互动。' },
    { part: '麦克风', desc: '设备通过麦克风接收孩子说话声音。' },
  ];

  return (
    <div className="kidopally-manual">
      <main className="kidopally-main">
        <Tabs
          className="manual-tabs"
          activeLineMode="fixed"
          defaultActiveKey="intro"
          onChange={(key) => {
            const element = document.getElementById(key);
            element?.scrollIntoView({ behavior: 'smooth' });
          }}
        >
          
          // 在产品介绍Tab中添加表格
          <Tabs.Tab title="产品介绍" key="intro">
            <div className="kidopally-content">
              {/* 产品介绍部分 */}
              <div className="kidopally-section">
                <p>宝贝多点AI，陪伴更自在！</p>
                <p className='kidopally-title'>这是一款专为孩子打造的智能陪伴玩具，拥有性格各异的毛绒角色——小可豆，通过先进的AI语音交互和互动游戏卡片，激发孩子的好奇心和探索精神，培养表达能力和创造力。未来还将推出更多性格和外观的角色，陪伴孩子快乐成长，让家长更省心。</p>
              </div>
              
              {/* 产品结构部分 */}
              <div className="kidopally-section">
                <h2>产品构成</h2>
                <p>产品由<span className='font-large'>小可豆</span>和<span className='font-large'>超能眼镜</span>两个主体共同构成，使用时需要将超能眼镜佩戴在小可豆身上，并将小可豆身上的NFC<span className='font-large'>小豆芽</span>插入眼镜的豆芽仓中。</p>
                <img src={`${OSS_PREFIX}/miniprogram/assets/pages/profiles/guide/product_composition.png`} 
                     alt="产品结构" className="kidopally-image step-image" />
              </div>

              {/* 眼镜功能部件 */}
              <div className="kidopally-section">
                <h2>眼镜功能部件</h2>
                <img src={`${OSS_PREFIX}/miniprogram/assets/pages/profiles/guide/glasses_composition.png`} 
                     alt="眼镜结构" className="kidopally-image step-image" />
              </div>

               {/* 功能部件表格 */}
              <div className="specs-table">
                <div className="table-header">
                  <div className="table-cell">部件</div>
                  <div className="table-cell">功能说明</div>
                </div>
                {componentSpecs.map((spec, index) => (
                  <div key={index} className="table-row">
                    <div className="table-cell">{spec.part}</div>
                    <div className="table-cell">{spec.desc}</div>
                  </div>
                ))}
              </div>

              

            </div>
          </Tabs.Tab>

          <Tabs.Tab title="快速上手" key="quickstart">
            <div className="kidopally-content">
              <List className="guide-steps">
                {steps.map((step, index) => (
                  <List.Item
                    key={index}
                    title={`${step.title}`}
                    description={
                      <div className="step-content">
                        {/* 渲染所有图片和提示 */}
                        {Object.entries(step).map(([key, value]) => {
                          if (key.startsWith('img')) {
                            return <img key={key} src={value as string} alt={step.title} className="step-image" />;
                          }
                          if (key.startsWith('tips') && !key.endsWith('Children')) {
                            return Array.isArray(value) && (
                              <div key={key} className="tip-group">
                                {value.map((tip, i) => (
                                  <div key={i} className="tip-item">
                                    {tip}
                                  </div>
                                ))}
                              </div>
                            );
                          }
                          if (key.startsWith('warring')) {
                            const warningText = (value as string).split('\n').map((line, i) => (
                              <div key={i}>{line}</div>
                            ));
                            return (
                              <div key={key} className="warning-tip">
                                {warningText}
                              </div>
                            );
                          }
                          if (key.endsWith('Children')) {
                            return (
                              <div key={key} className="children-container">
                                {Object.entries(value).map(([subKey, subValue]) => (
                                  <div key={subKey}>
                                    {subKey === 'tip' && typeof subValue === 'string' && (
                                      <div className="sub-tip-item">{subValue}</div>
                                    )}
                                    {subKey === 'img' && typeof subValue === 'string' && (
                                      <img src={subValue} alt={step.title} className="sub-step-image" />
                                    )}
                                    {subKey === 'warring' && typeof subValue === 'string' && (
                                      <div className="sub-warning warning-tip">
                                        {subValue.split('\n').map((line, i) => (
                                          <div key={i}>{line}</div>
                                        ))}
                                      </div>
                                    )}
                                  </div>
                                ))}
                              </div>
                            );
                          }
                          return null;
                        })}
                      </div>
                    }
                  />
                ))}
              </List>
            </div>
          </Tabs.Tab>

          // 修改功能速查Tab内容
          <Tabs.Tab title="常用操作" key="features">
            <div className="kidopally-content">
              <FeatureQuickCheck />
            </div>
          </Tabs.Tab>
          <Tabs.Tab title="常见问题" key="faq">
            <div className="kidopally-content">
              <FAQ />
            </div>
          </Tabs.Tab>
        </Tabs>
      </main>

      <footer className="kidopally-footer">
        <p>Copyright © 2025 Kidopally. All Rights Reserved<br/><a href="https://beian.miit.gov.cn/" target="_blank" className="footer-link">京ICP备2025103694号-3</a></p>
      </footer>
    </div>
  );
};

export default ProductManual;